import { tampleteEditRoute } from '@features/enterprise/api/constants';
import { errorMessage, Timezone } from '@features/profile';
import axiosInstance from '@server/axiosInstance';
import { Dispatch, SetStateAction } from 'react';
import { useMutation, useQueryClient } from 'react-query';

import { templateList } from '../constants';

type useEditTemplateProps = {
  setErrorText?: Dispatch<SetStateAction<string>>;
};

type WhyWorkBlock = {
  f_icon?: string;
  heading?: string;
  description?: string;
};

type EditTemplateVariables = {
  template_id: number;
  name?: string;
  industry_id?: string | number;
  description?: string;
  status?: number;
  company_id?: number;
  alert_message_email?: 0 | 1;
  alert_application_email?: 0 | 1;
  alert_reference_email?: 0 | 1;
  s_phone?: string;
  s_name?: string;
  email?: string;
  s_address1?: string;
  s_website_url?: string;
  our_hiring_culture?: string;
  color1?: string;
  color2?: string;
  default_declined_message?: string;
  default_saved_message?: string;
  default_interview_message?: string;
  default_open_interview_message?: string;
  default_hire_message?: string;
  default_declined_post_interview_message?: string;
  default_saved_post_interview_message?: string;
  default_request_more_info_message?: string;
  default_archive_message?: string;
  unresponsive_message?: string;
  unresponsive_interview?: string;
  keep_declined_applications?: boolean;
  keep_unattended_applications?: boolean;
  timezone?: Timezone;
  physical_interview_address?: string | boolean;
  physical_interview_location?: string | null;
  virtual_interview_link?: string | null;
  hire_flix_location?: boolean | string;
  why_we_work?: {
    heading?: string;
    blocks: WhyWorkBlock[];
  } | null;
};

export const useEditTemplate = ({
  setErrorText = () => {},
}: useEditTemplateProps) => {
  const client = useQueryClient();

  const { mutate: editTemplate, isLoading: isUpdatingTemplate } = useMutation({
    mutationFn: (variables: EditTemplateVariables) =>
      axiosInstance.post(tampleteEditRoute, variables).then((res) => res.data),
    onSuccess: (data) => {
      if (data.status !== 200) {
        setErrorText(data.message);
      } else {
        setErrorText('');
        client.invalidateQueries([templateList]);
      }
    },
    onError: () => setErrorText(errorMessage),
  });

  return {
    editTemplate,
    isUpdatingTemplate,
  };
};
